import { currrencyFomats } from './currency-formats.const'

/**
 * Get the currency format based on the currency code,
 * defaults to 'en-GB'.
 *
 * @param currency ISO 4217 currency code
 * @returns the currency format based on the currency code
 */
export const getFormatFromCurrencyCode = (currencyCode: string) => {
  const format =
    currrencyFomats[currencyCode.toUpperCase() as keyof typeof currrencyFomats]

  if (!format) {
    throw new Error(
      `Currency code ${currencyCode.toUpperCase()} is not supported.`,
    )
  }

  return format
}
